import { Group, Text, ThemeIcon } from '@mantine/core';
import { forwardRef } from 'react';

const PrioritySelectItem = forwardRef(({ label, icon, color, ...others }, ref) => (
    <div ref={ref} {...others}>
        <Group noWrap spacing="xs">
            <ThemeIcon size="sm" variant="light" color={color}>
                {icon}
            </ThemeIcon>
            <Text size="sm">{label}</Text>
        </Group>
    </div>
));

PrioritySelectItem.displayName = 'PrioritySelectItem';

export default PrioritySelectItem;
